import styled from 'styled-components'

export const StyledNewsResultsCount = styled.span`
  font-size: 14px;
`
